export const AUTH_REGISTER_DEVICE_REQUEST = 'AUTH_REGISTER_DEVICE_REQUEST';

export const AUTH_REQUEST_OTP_REQUEST = 'AUTH_REQUEST_OTP_REQUEST';
export const AUTH_REQUEST_OTP_SUCCESS = 'AUTH_REQUEST_OTP_SUCCESS';
export const AUTH_REQUEST_OTP_FAILURE = 'AUTH_REQUEST_OTP_FAILURE';

export const AUTH_VERIFY_OTP_REQUEST = 'AUTH_VERIFY_OTP_REQUEST';
export const AUTH_VERIFY_OTP_SUCCESS = 'AUTH_VERIFY_OTP_SUCCESS';
export const AUTH_VERIFY_OTP_FAILURE = 'AUTH_VERIFY_OTP_FAILURE';

export const AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const AUTH_LOGOUT_FAILURE = 'AUTH_LOGOUT_FAILURE';

export const CHECK_BLACK_LIST = 'CHECK_BLACK_LIST';
export const CHECK_BLACK_LIST_SUCCESS = 'CHECK_BLACK_LIST_SUCCESS';
export const CHECK_BLACK_LIST_FAILURE = 'CHECK_BLACK_LIST_FAILURE';

export const AUTH_SELECT_ACCOUNT = 'AUTH_SELECT_ACCOUNT';

export const AUTH_RESET_OTP_ERROR = 'AUTH_RESET_OTP_ERROR';

export const GET_MST_KEY = 'GET_MST_KEY';
export const GET_MST_KEY_SUCCESS = 'GET_MST_KEY_SUCCESS';
export const GET_MST_KEY_FAILURE = 'GET_MST_KEY_FAILURE';

export const GET_GLOBAL_CONFIGS_REQUEST = 'GET_GLOBAL_CONFIGS_REQUEST';
export const GET_GLOBAL_CONFIGS_SUCCESS = 'GET_GLOBAL_CONFIGS_SUCCESS';
export const GET_GLOBAL_CONFIGS_FAILURE = 'GET_GLOBAL_CONFIGS_FAILURE';

export const AUTH_SET_UDF_DETAILS = 'AUTH_SET_UDF_DETAILS';
export const AUTH_SET_UDF_TOKEN_DETAILS = 'AUTH_SET_UDF_TOKEN_DETAILS';

export const AUTH_TOKEN_REQUEST = 'AUTH_TOKEN_REQUEST';
export const AUTH_TOKEN_SUCCESS = 'AUTH_TOKEN_SUCCESS';
export const AUTH_TOKEN_FAILURE = 'AUTH_TOKEN_FAILURE';

export const GET_PDPA_ORDER_REQUEST = 'GET_PDPA_ORDER_REQUEST';
export const GET_PDPA_ORDER_SUCCESS = 'GET_PDPA_ORDER_SUCCESS';
export const GET_PDPA_ORDER_FAILURE = 'GET_PDPA_ORDER_FAILURE';

export const GET_PDPA_KEY_REQUEST = 'GET_PDPA_KEY_REQUEST';
export const GET_PDPA_KEY_SUCCESS = 'GET_PDPA_KEY_SUCCESS';
export const GET_PDPA_KEY_FAILURE = 'GET_PDPA_KEY_FAILURE';

export const USER_GROUP_POLICIES_REQUEST = 'USER_GROUP_POLICIES_REQUEST';
export const USER_GROUP_POLICIES_SUCCESS = 'USER_GROUP_POLICIES_SUCCESS';
export const USER_GROUP_POLICIES_FAILURE = 'USER_GROUP_POLICIES_FAILURE';

export const REGISTER_UDF_MYEMPOWER_REQUEST = 'REGISTER_UDF_MYEMPOWER_REQUEST';

export const REGISTER_UDF_EMPOWER_REQUEST = 'REGISTER_UDF_EMPOWER_REQUEST';

export const REGISTER_UDF_PDPA_REQUEST = 'REGISTER_UDF_PDPA_REQUEST';

export const REGISTER_DEVICE_MFA_REQUEST = 'REGISTER_DEVICE_MFA_REQUEST';
export const REGISTER_DEVICE_MFA_SUCCESS = 'REGISTER_DEVICE_MFA_SUCCESS';
export const REGISTER_DEVICE_MFA_FAILURE = 'REGISTER_DEVICE_MFA_FAILURE';

export const AUTH_CHKBLKLIST_SUCCESS = 'AUTH_CHKBLKLIST_SUCCESS';

export const GET_EMPOWER_USER_DETAILS_REQUEST = 'GET_EMPOWER_USER_DETAILS_REQUEST';
export const GET_EMPOWER_USER_DETAILS_SUCCESS = 'GET_EMPOWER_USER_DETAILS_SUCCESS';
export const GET_EMPOWER_USER_DETAILS_FAILURE = 'GET_EMPOWER_USER_DETAILS_FAILURE';

export const UPDATE_EMPOWER_USER_DETAILS_REQUEST = 'UPDATE_EMPOWER_USER_DETAILS_REQUEST';
export const UPDATE_EMPOWER_USER_DETAILS_SUCCESS = 'UPDATE_EMPOWER_USER_DETAILS_SUCCESS';
export const UPDATE_EMPOWER_USER_DETAILS_FAILURE = 'UPDATE_EMPOWER_USER_DETAILS_FAILURE';

export const SET_EMPOWER_PATH_REDIRECTED = 'SET_EMPOWER_PATH_REDIRECTED';

export const GET_STAFF_LOGIN_DETAILS_REQUEST = 'GET_STAFF_LOGIN_DETAILS_REQUEST';
export const GET_STAFF_LOGIN_DETAILS_SUCCESS = 'GET_STAFF_LOGIN_DETAILS_SUCCESS';
export const GET_STAFF_LOGIN_DETAILS_FAILURE = 'GET_STAFF_LOGIN_DETAILS_FAILURE';

export const GET_WAIVER_LOGIN_DETAILS_REQUEST = 'GET_WAIVER_LOGIN_DETAILS_REQUEST';
export const GET_WAIVER_LOGIN_DETAILS_SUCCESS = 'GET_WAIVER_LOGIN_DETAILS_SUCCESS';
export const GET_WAIVER_LOGIN_DETAILS_FAILURE = 'GET_WAIVER_LOGIN_DETAILS_FAILURE';
